// extracted by mini-css-extract-plugin
module.exports = {"container":"MiroTemplate_container__DjYUC","image":"MiroTemplate_image__7c4Cm","heading":"MiroTemplate_heading__38GSU"};